var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtisBigd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1565 509",
    width: 1565,
    height: 509,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Otis_logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fillRule: "evenodd",
    className: "s0",
    d: "m372.5 31.3c71.9 37.2 113.6 116.9 119.2 195.7 6.4 68.6-9 141.6-53 195.9-36.8 46.7-93.1 77.4-152.3 83.2-67.6 7.8-140.6-3-194.6-46.8-98.5-78.8-115.7-230.8-58.4-338.6 34.2-65.2 102.2-108.5 174.5-118.1 14-1.3 28.2-2 42.4-1.8 42.6 0.6 85 9.1 122.2 30.5zm-147.6 89.7c-47.4 11.6-72.5 60.7-75.5 106.2-3.9 47.5-1.3 102.9 35.1 138.3 31 32.7 87.4 34.2 120.9 4.8 22.5-20.8 35.6-50.4 38.7-80.6 5.6-44.8 3.2-94.6-23.4-132.9-16.2-24.9-46.2-38.4-75.7-38.2-6.8 0.1-13.5 0.8-20.1 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "s0",
    d: "m1192.2 50.3c54.6-48.6 133-54.6 202.5-46.5 35.3 6.6 71.4 17.1 99.3 40.8 33.8 26.6 48 70.4 51 111.9-45.4 0-90.8-0.2-136.3 0.2-4.7-54.5-81.9-66.8-117.4-35-13.7 18-0.6 40.7 18.5 47.6 69.9 29.8 152.8 29 214.1 78.6 36.3 28.7 45.2 78.7 38.4 122.3-4 43.9-32.5 83.3-70.8 104.2-51.6 31.1-113.9 36-172.7 33.1-50.7-2.5-102.3-18-141.1-51.6-33.6-29.4-50.3-74.5-50.3-118.5 48.5-1 97-1.2 145.5 0.1 4.2 21.3 8.3 47.1 30.6 57.1 39.2 19.1 106.6 16.4 117.2-35.9-5.2-9-7.3-21.1-17.5-26.1-70.8-36.5-158.3-35.5-221.7-87.3-54.9-50.7-41.9-147.2 10.7-195zm-699.4-37.7c140.7-0.6 281.5-0.3 422.3-0.1-0.5 40.4-0.2 80.8-0.2 121.2-45.8 0.2-91.6-0.8-137.3 0.6-2.1 121.3 1.1 242.7-1.6 363.9-48.5-0.4-96.9 0.7-145.3-0.7-1.6-121.2 0.1-242.4-0.9-363.5-45.6-0.6-91.2-0.3-136.9-0.3 0.8-40.3 0.8-80.7-0.1-121.1zm458.4-0.3c48.7-0.3 97.7 0.3 146.5-0.3 0.9 161.9 1.5 324 0.3 485.9-49.1 0-98.1 1.2-147.1-0.8 0.3-161.6-0.2-323.2 0.3-484.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtisBigd);
export default __webpack_public_path__ + "static/media/OTIS_BIG.D.a40fb75c6f8a5956c03a8bb00c150207.svg";
export { ForwardRef as ReactComponent };